import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=3dba02d1"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=3dba02d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports